module.exports = __webpack_public_path__ + "img/99.9.6ca90799.png";